/**
 * Converts bytes into a readable size (Bytes, KB, MB, GB, TB, ...)
 *
 * Taken from: https://stackoverflow.com/questions/15900485/correct-way-to-convert-size-in-bytes-to-kb-mb-gb-in-javascript
 * @param bytes the total bytes
 * @param decimals prefered decimals for the formatted size
 * @returns a string representing the size.
 */
export function formatBytes(bytes: number, decimals = 2) {
  if (bytes < 0) return 'Incorrect byte size';
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}
